// import { getAriaLabelFromOuterHTML } from '../utils/skin.utils';
import { scrollToTop, isMobile } from '../utils/utils';
import { validateField, userPINameSchema } from '../utils/validation.utils';
import { handleAnalyzeScreenOnLoad } from './analyze.handlers';

let analyticsService = null;

// skin-quiz

const handleQuizScreenOnLoad = async ({ event, data }) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const quizScreenData = data;
    let isUserPI;

    let formattedData = quizScreenData.map(({ data: { quiz } }) => {
      return quiz.data.questions.map(question => {
        const { questionId, questionType, questionText, groupId, answers } = question.data;
        if (groupId !== 'userPI') {
          const answersData = answers.data.map(({ answerId, answerText, surveyQuestionId }) => {
            return { answerId, title: answerText, surveyQuestionId };
          });
          return {
            groupId,
            questionId,
            type: questionType,
            title: questionText,
            answers: answersData,
          };
        }
        if (groupId === 'userPI') {
          isUserPI = true;
        }
      });
    });
    formattedData = formattedData.filter(item => item[0]);

    await handlers.updateQuizData(quizScreenData);
    await handlers.updateQuizFormattedData(formattedData);

    let { showIntro, showQuiz, currentIntroIndex, currentQuizIndex, selectedOptions, quizPlainIndex, quizData } = await handlers.getQuizState();

    let questionsList = 0;
    quizData.map(item => {
      questionsList = item.data.quiz.data.questions.length + questionsList;
    });

    const duration = 2000; // Transition duration in milliseconds
    const targetDegrees = (360 / questionsList) * (quizPlainIndex + 1);
    let startTime;

    function updateGradient(timestamp, startDegrees) {
      const progressFill = document.querySelector('aiba-app').shadowRoot.querySelector('.progress') as any;

      if (progressFill) {
        const currentTime = timestamp - startTime;
        const currentDegrees = startDegrees + (currentTime / duration) * (targetDegrees - startDegrees);

        progressFill.style.background = `conic-gradient(#dbc081 ${currentDegrees}deg, rgba(0,0,0,0) 0deg)`;

        if (currentTime < duration) {
          requestAnimationFrame(timestamp => updateGradient(timestamp, startDegrees));
        }
      }
    }

    async function focusElement(timestamp) {
      const progressFill = document.querySelector('aiba-app')?.shadowRoot?.querySelector('.progress') as any;
      const option_container = document.querySelector('aiba-app')?.shadowRoot?.querySelector('.grid-option-wrapper') as any;

      if (quizPlainIndex + 1 === questionsList) {
        let analyse_CTA = document.querySelector('aiba-app').shadowRoot?.querySelector('.quiz-button-container aiba-button:nth-child(2)') as any;
        if (analyse_CTA && handlers.disabled) analyse_CTA?.classList?.add('disabled');
      }

      if (progressFill && option_container) {
        let startDegrees;
        const currentStyle = window.getComputedStyle(progressFill);
        let currentGradient = currentStyle.backgroundImage.match(/([0-9.]+)deg/);
        startDegrees = currentGradient ? parseFloat(currentGradient[1]) : 0;
        if (startDegrees !== 0 && quizPlainIndex !== 0) {
          await handlers.setRotation(startDegrees);
        }
        if (!currentGradient && quizPlainIndex !== 0) {
          currentGradient = await handlers.getRotation();
          startDegrees = currentGradient;
        }

        if (!startTime) {
          startTime = timestamp;
        }

        if (quizData[currentIntroIndex].data.quiz.data.questions[currentQuizIndex].data.answers.data.length > 4) {
          option_container?.classList?.add('optionBlock');
        } else {
          if (option_container?.classList?.contains('optionBlock')) {
            option_container?.classList?.remove('optionBlock');
          }
        }
        const quiz_cta = document.querySelector('aiba-app')?.shadowRoot?.querySelector('.quiz-button-container') as any;
        if (currentIntroIndex > 0) {
          if (quiz_cta) quiz_cta.style.display = 'flex';
        }
        updateGradient(timestamp, startDegrees);
      } else {
        if (!startTime) {
          startTime = timestamp;
        }
        const elapsedTime = timestamp - startTime;
        if (elapsedTime < 1000) {
          requestAnimationFrame(focusElement);
        }
      }
    }
    requestAnimationFrame(focusElement);

    if (!isUserPI) {
      showIntro = false;
      showQuiz = true;
      await handlers.updateQuizCountersAndShowStates(currentIntroIndex, currentQuizIndex, showIntro, showQuiz, quizPlainIndex);
    }
    handleBGscroll();
    return { showIntro, showQuiz, currentIntroIndex, currentQuizIndex, selectedOptions, quizPlainIndex };
  }
  console.log('@AIBA[handleQuizScreenOnLoad]', event);
};
export const checkNextQuestions = (data, index, groupData, groupIndex) => {
  if (index + 1 < data.length) {
    index += 1;
    return { index, groupIndex };
  } else {
    if (groupIndex + 1 < groupData.length) {
      groupIndex += 1;
      return { index: 0, groupIndex };
    } else {
      return { index: -1, groupIndex: -1 };
    }
  }
};
export const checkPrevQuestions = (data, index, groupData, groupIndex) => {
  console.log('@AIBA[checkPrevQuestions]', data);

  if (index - 1 >= 0) {
    index -= 1;
    return { index, groupIndex };
  } else {
    if (groupIndex - 1 >= 0) {
      groupIndex -= 1;
      return { index: groupData[groupIndex].data.quiz.data.questions.length - 1, groupIndex };
    } else {
      return { index: -1, groupIndex: -1 };
    }
  }
};

const prepareEventData = async (event, question, selectedOptions, currentQues, totalQues) => {
  // const userPIquestionslength = 3;
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    console.log('event,total', totalQues, event);
    let analysisState = await handlers.getStateRetakeJourney();
    let analysisStateText = `skin analysis - ${analysisState ? 'retake' : 'take'} quiz`;
    const eventData = {};
    eventData['label'] = `Question ${currentQues}`;
    eventData['questionId'] = question['questionId'];
    eventData['component'] = `Skin Analysis`;
    eventData['quizInfo'] = `${analysisStateText}`;
    eventData['questionText'] = question.questionText;
    const quesOptions = question.answers['data'];
    if (quesOptions.length) {
      eventData['subattributes'] = [];
      let selectedAnswerTextArray: any = [];
      if (selectedOptions[currentQues - 1].length >= 1) {
        quesOptions.map(option => {
          if (selectedOptions[currentQues - 1].includes(option['answerId'])) {
            selectedAnswerTextArray.push(option['answerText']);
          }
        });
      }
      quesOptions.forEach(option => {
        if (selectedOptions[currentQues - 1].includes(option['answerId'])) {
          eventData['subattributes'].push({
            DTQns: question.questionText,
            DTAns: selectedOptions[currentQues - 1].length > 1 ? selectedAnswerTextArray : option.answerText,
            DTQnsID: question.questionId,
            DTAnsID: selectedOptions[currentQues - 1].length > 1 ? selectedOptions[currentQues - 1] : option.answerId,
          });
        }
      });
    }
    return eventData;
  }
};

const handleNextQuestionClick = async event => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    let { currentIntroIndex, currentQuizIndex, quizData, quizPlainIndex, selectedOptions } = await handlers.getQuizState();
    handlers.disabled = true;

    const nextButtonTitle = quizData[currentIntroIndex]?.data?.quiz?.data?.next?.data?.title;

    if (quizData[currentIntroIndex].data.quiz.data.questions[currentQuizIndex].data.questionMandatory) {
      if (!selectedOptions[quizPlainIndex] || (selectedOptions[quizPlainIndex] && Object.keys(selectedOptions[quizPlainIndex].filter(item => item)).length < 1)) {
        let event = new CustomEvent('event-options-error', { detail: 'required' });
        document.dispatchEvent(event);
        return quizData[currentIntroIndex].data.quiz.data.questions[currentQuizIndex].data.questionMandatory;
      }
    }
    if (quizData[currentIntroIndex].data.quiz.data.questions[currentQuizIndex].data.questionId === 'name') {
      await handlers.updateUserName(selectedOptions[quizPlainIndex][0]);
      const error = await handleValidationUserPIName(selectedOptions[quizPlainIndex][0]);
      if (error.message) {
        return error.details[0].message;
      }
    }
    const { index, groupIndex } = checkNextQuestions(quizData[currentIntroIndex].data.quiz.data.questions, currentQuizIndex, quizData, currentIntroIndex);
    const showQuizIntro = !!(currentIntroIndex !== groupIndex && groupIndex !== -1);
    const showQuiz = !showQuizIntro;
    analyticsService = handlers.analyticsService;

    let questionsList = quizData[currentIntroIndex].data.quiz.data.questions;
    // analytics trigger

    const userPI = questionsList[currentQuizIndex]?.data.groupId;
    if (userPI !== 'userPI') {
      event['data'] = await prepareEventData(event, questionsList[currentQuizIndex]?.data, selectedOptions, quizPlainIndex + 1, questionsList.length);
      analyticsService?.registerEvent('event24', event);
    }
    if (userPI === 'userPI') {
      // let arialabel = '';
      // arialabel = event?.currentTarget?.ariaLabel ? event?.currentTarget?.ariaLabel : getAriaLabelFromOuterHTML(event?.currentTarget?.outerHTML, 'button');
      // event.target['eventTitle'] = `${arialabel} - ${questionsList[currentQuizIndex]?.data?.questionId}`;
      if (event.target) {
        event.target['eventTitle'] = nextButtonTitle;
      }
      analyticsService.registerEvent('event2', event);
    }
    if (selectedOptions[quizPlainIndex + 1]) {
      delete selectedOptions[quizPlainIndex + 1];
    }
    if (index !== -1 && groupIndex !== -1) {
      currentIntroIndex = groupIndex;
      currentQuizIndex = index;
      await handlers.updateQuizCountersAndShowStates(currentIntroIndex, currentQuizIndex, showQuizIntro, showQuiz, quizPlainIndex + 1);
      let event = new CustomEvent('event-quizscreen', { detail: 'required' });
      document.dispatchEvent(event);
    }
    scrollToTop();
    document.body.setAttribute('tabindex', '-1');
    if (!isMobile()) {
      document.body.focus();
    }
    const mainDiv = document.querySelector('aiba-app').shadowRoot.querySelector('.screen-wrapper.quiz_screen aiba-quiz') as HTMLElement;
    mainDiv.classList?.add('fadestyle');
  }
};

const handlePrevQuestionClick = async (e, ...args) => {
  console.log('@AIBA[handlePrevQuestionClick]', e, ...args);
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    handlers.disabled = true;
    let { currentIntroIndex, currentQuizIndex, quizData, quizPlainIndex, selectedOptions } = await handlers.getQuizState();
    const { index, groupIndex } = checkPrevQuestions(quizData[currentIntroIndex].data.quiz.data.questions, currentQuizIndex, quizData, currentIntroIndex);
    const showQuizIntro = !!(currentIntroIndex !== groupIndex && groupIndex !== -1 && currentIntroIndex < groupIndex);
    const showQuiz = !showQuizIntro;
    // let questionsList = quizData[currentIntroIndex].data.quiz.data.questions;
    if (selectedOptions[quizPlainIndex - 1]) {
      delete selectedOptions[quizPlainIndex - 1];
    }

    const prevButtonTitle = quizData[currentIntroIndex]?.data?.quiz?.data?.prev?.data?.title;

    analyticsService = handlers.analyticsService;

    // let arialabel = '';
    // arialabel = e?.currentTarget?.ariaLabel ? e?.currentTarget?.ariaLabel : getAriaLabelFromOuterHTML(e?.currentTarget?.outerHTML, 'button');

    // e.target['eventTitle'] = `${arialabel} - ${questionsList[currentQuizIndex]?.data?.questionText}`;
    e.target['eventTitle'] = prevButtonTitle;

    analyticsService?.registerEvent('event2', e);

    //only trigger event if quizGroup is not userPI.

    if (index !== -1 && groupIndex !== -1) {
      currentIntroIndex = groupIndex;
      currentQuizIndex = index;
      await handlers.updateQuizCountersAndShowStates(currentIntroIndex, currentQuizIndex, showQuizIntro, showQuiz, quizPlainIndex - 1);
      let event = new CustomEvent('event-quizscreen', { detail: 'required' });
      document.dispatchEvent(event);
    } else {
      await handlers.getPrevJourney('quiz_screen');
    }
    scrollToTop();
    document.body.setAttribute('tabindex', '-1');
    if (!isMobile()) {
      document.body.focus();
    }
  }
};

const handleQuizIntroCTAClick = async event1 => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const { currentIntroIndex, currentQuizIndex, quizData, quizPlainIndex } = await handlers.getQuizState();
    await handlers.updateQuizCountersAndShowStates(currentIntroIndex, currentQuizIndex, false, true, quizPlainIndex);
    // Create the event
    let event = new CustomEvent('event-quizscreen', { detail: 'required' });
    document.dispatchEvent(event);

    analyticsService = handlers.analyticsService;

    if (currentIntroIndex === 1) {
      event1['total'] = quizData.reduce((accumulator, index, arrayIndex) => {
        return accumulator + arrayIndex !== 0 ? index.data.quiz.data.questions.length : 0;
      }, 0);

      let quizInfo: string = '';
      let analysisState = await handlers.getStateRetakeJourney();
      let analysisStateText = `skin analysis - ${analysisState ? 'retake' : 'take'} quiz`;
      quizInfo = analysisStateText;

      event1['data'] = { label: quizInfo };

      analyticsService?.registerEvent('event16', event1);
    } else {
      let quizCTA = quizData[currentIntroIndex].data.groupIntro.data.elements[1].data.value;
      // let arialabel = '';
      // arialabel = event1?.currentTarget?.ariaLabel ? event1?.currentTarget?.ariaLabel : getAriaLabelFromOuterHTML(event1?.currentTarget?.outerHTML, 'button');
      // event1.target['eventTitle'] = arialabel;
      event1.target['eventTitle'] = quizCTA;

      analyticsService?.registerEvent('event2', event1);
    }
  }
};
const handleAnalyzeQuestionClick = async event => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    let { currentIntroIndex, currentQuizIndex, quizData, quizPlainIndex, selectedOptions, quizFormattedData } = await handlers.getQuizState();
    if (quizData[currentIntroIndex].data.quiz.data.questions[currentQuizIndex].data.questionMandatory) {
      if (!selectedOptions[quizPlainIndex] || (selectedOptions[quizPlainIndex] && selectedOptions[quizPlainIndex].filter(x => x !== '').length < 1)) {
        let event = new CustomEvent('event-options-error', { detail: 'required' });
        document.dispatchEvent(event);
        return quizData[currentIntroIndex].data.quiz.data.questions[currentQuizIndex].data.questionMandatory;
      }
    }

    const userPI = quizData.find(({ data }) => data['groupId'] === 'userPI');
    let length = userPI?.data?.quiz?.data?.questions?.length;
    let formattedPayload = [];
    quizFormattedData.map(elem => {
      elem.map(item => {
        formattedPayload.push(item);
      });
    });
    const quizPayloadData = formattedPayload
      .map((question, index) => {
        if (selectedOptions[index + (length ? length : 0)]) {
          const valArray = selectedOptions[index + (length ? length : 0)];
          const answers = question.answers.filter(answer => valArray.includes(answer.answerId));
          if (answers.length > 0) {
            return { ...question, answers };
          }
        }
        return null;
      })
      .filter(item => item);

    analyticsService = handlers.analyticsService;

    await handlers.updateQuizPayloadForML(quizPayloadData);

    let questionsList = quizData[currentIntroIndex].data.quiz.data.questions;

    event['data'] = await prepareEventData(event, questionsList[currentQuizIndex].data, selectedOptions, quizPlainIndex + 1, questionsList.length);

    await analyticsService?.registerEvent('event24', event);
    const btnDiv = document.querySelector('aiba-app').shadowRoot.querySelector('.quiz-button-container .quiz-button') as HTMLElement;
    btnDiv.classList?.add('ripple');
    await handlers.updateQuizPayload(quizPayloadData);
    setTimeout(()=>{
      btnDiv.classList?.remove('ripple');
    },1000)
    try {
      await handleAnalyzeScreenOnLoad();
      await handlers.getNextJourney('quiz_screen');
    } catch (error) {
      console.error('@AIBA[getArticlesApi]:', error);
    }
  }
};
const handleQuizOptionSelected = async selectedOptions => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const { currentIntroIndex, currentQuizIndex, quizData, quizPlainIndex } = await handlers.getQuizState();
    await handlers.updateQuizOptionSelected(quizPlainIndex, selectedOptions);
    const mainDiv = document.querySelector('aiba-app').shadowRoot.querySelector('.screen-wrapper.quiz_screen aiba-quiz') as HTMLElement;
    if (quizData[currentIntroIndex].data.groupId !== 'userPI') {
      let questionsList = quizData[currentIntroIndex].data.quiz.data.questions;
      let totalQues = 0;
      quizData.map(item => {
        totalQues = item.data.quiz.data.questions.length + totalQues;
      });
      if (questionsList.length !== currentQuizIndex && quizPlainIndex + 1 !== totalQues) {
        setTimeout(() => {
          mainDiv.classList?.remove('fadestyle');
          handleNextQuestionClick(selectedOptions);
        }, 500);
      }
      if (quizPlainIndex + 1 === totalQues) {
        let analyse_CTA = document.querySelector('aiba-app').shadowRoot.querySelector('.quiz-analyse-button') as any;
        analyse_CTA?.classList?.remove('disabled');
        handlers.disabled = false;
      }
    }
    // Create the event
    let event = new CustomEvent('event-quizscreen', { detail: 'required' });
    document.dispatchEvent(event);
    handleBGscroll();
  }
};

const handleBGscroll = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const config = await handlers.getConfig();
    let journeyType = config.brand.journey_type;
    const mainDiv = document.querySelector('aiba-app').shadowRoot.querySelector('.screen-wrapper.quiz_screen') as HTMLElement;
    const { quizPlainIndex, quizData } = await handlers.getQuizState();
    let questionsTotalList = 0;
    quizData.map(item => {
      questionsTotalList = item.data.quiz.data.questions.length + questionsTotalList;
    });
    let upValue;
    if (journeyType === 'self-care') {
      switch (quizPlainIndex) {
        case 0:
          upValue = 0;
          break;
        case 1:
          upValue = 9;
          break;
        case 2:
          upValue = 17;
          break;
        case 3:
          upValue = 24;
          break;
        case 4:
          upValue = 34;
          break;
        default:
          upValue = 1;
          break;
      }
    } else {
      switch (quizPlainIndex) {
        case 0:
          upValue = 5;
          break;
        case 1:
          upValue = 25;
          break;
        case 2:
          upValue = 45;
          break;
        case 3:
          upValue = 70;
          break;
        case 4:
          upValue = 83;
          break;
        default:
          upValue = 5;
          break;
      }
    }

    mainDiv.style.backgroundPosition = `0px ${upValue}%`;
  }
};
const handleValidationUserPIName = async value => {
  try {
    const result = await validateField('name', value, userPINameSchema);
    if (result.message) {
      let event = new CustomEvent('event-options-error', { detail: result.details[0].message });
      document.dispatchEvent(event);
      if (window['AIBA'] && window['AIBA']['utils']) {
        const handlers = window['AIBA']['utils'];
        analyticsService = handlers.analyticsService;

        analyticsService?.registerEvent('event32', { label: result.details[0].message, error: result.details[0].message });
      }
    }
    return result;
  } catch (error) {
    console.error(error);
    return error;
  }
};
const handleUserName = async value => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];

    analyticsService = handlers.analyticsService;

    return value.split('{{USERNAME}}').join(await handlers.getUserName());
  }
};

const quizQuestionHandler = question => {
  analyticsService?.registerEvent('event1', { page: `aiba quiz - question : ${question}` });
};

const quizIntrohandler = () => {
  analyticsService?.registerEvent('event1', { page: `aiba quiz intro` });
};

export {
  handleQuizScreenOnLoad,
  handleNextQuestionClick,
  handlePrevQuestionClick,
  handleQuizIntroCTAClick,
  handleQuizOptionSelected,
  handleAnalyzeQuestionClick,
  handleValidationUserPIName,
  handleUserName,
  quizQuestionHandler,
  quizIntrohandler,
};
